<template>
  <ContactList :portal-company="portalCompany"/>
</template>

<script>
import ContactList from "../../../../../../components/Companies/Contacts/Panels/List"

export default {
  components: {ContactList},

  props: {
    portalCompany: {
      required: true
    }
  }
}
</script>
